<template>
  <div class="patient-details">
    <step-header
      :title="headerTitle"
      :subtitle="locationName"
    />
    <div class="body">
      <form
        novalidate
        @submit.prevent="onClickNext"
      >
        <div class="reviewer-info">
          <div class="reputation-row">
            <div class="reputation-col">
              <pp-input-text
                ref="firstName"
                v-model="firstName"
                label="First name"
                name="first_name"
                type="text"
                autocomplete="given-name"
                hide-details
                data-cy="first-name"
                :error="showError('firstName')"
                :aria-invalid="showError('firstName') ? 'true' : 'false'"
                :aria-describedby="showError('firstName') ? 'first-name-error' : null"
              />
              <span
                v-if="showError('firstName')"
                id="first-name-error"
                class="validation-error"
              >* required</span>
            </div>
            <div class="reputation-col">
              <pp-input-text
                ref="lastName"
                v-model="lastName"
                label="Last name"
                name="last_name"
                type="text"
                autocomplete="family-name"
                hide-details
                data-cy="last-name"
                :error="showError('lastName')"
                :aria-invalid="showError('lastName') ? 'true' : 'false'"
                :aria-describedby="showError('lastName') ? 'last-name-error' : null"
              />
              <span
                v-if="showError('lastName')"
                id="last-name-error"
                class="validation-error"
              >* required</span>
            </div>
          </div>
          <pp-input-text
            ref="email"
            v-model="email"
            label="Email address"
            name="email"
            type="email"
            autocomplete="email"
            hide-details
            data-cy="email"
            :error="showError('email')"
            :aria-invalid="showError('email') ? 'true' : 'false'"
            :aria-describedby="showError('email') ? 'email-error' : null"
          />
          <span
            v-if="showError('email')"
            id="email-error"
            class="validation-error"
          >* invalid email</span>
          <pp-button
            class="btn-next"
            type="primary"
            text="Next"
            submit
            data-cy="patient-details-next"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import StepHeader from '@/components/StepHeader/StepHeader.vue'
import { trackView, trackClick } from '@/analytics'

export default {
  name: 'PatientDetails',
  components: { StepHeader },
  data () {
    return {
      firstName: '',
      lastName: '',
      email: ''
    }
  },
  validations: {
    firstName: { required },
    lastName: { required },
    email: { required, email }
  },
  computed: {
    ...mapGetters({
      headerTitle: 'reputation/headerTitle',
      locationName: 'reputation/locationName',
      patientInfo: 'reputation/patientInfo',
      analyticsDims: 'reputation/analyticsDims'
    })
  },
  created () {
    this.firstName = this.patientInfo.firstName || ''
    this.lastName = this.patientInfo.lastName || ''
    this.email = this.patientInfo.email || ''
    trackView(this, 'patient_details', this.analyticsDims)
  },
  methods: {
    ...mapActions({
      setPatientInfo: 'reputation/setPatientInfo'
    }),
    showError (field) {
      return this.$v[field].$dirty && this.$v[field].$invalid
    },
    // pp-input-text wraps the native input, so the ref is a component.
    focusField (field) {
      const ref = this.$refs[field]
      if (!ref) return
      const input = ref.$el ? ref.$el.querySelector('input') : ref
      if (input && input.focus) input.focus()
    },
    validForm () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    onClickNext () {
      this.firstName = this.firstName.trim()
      this.lastName = this.lastName.trim()
      this.email = this.email.trim()
      if (!this.validForm()) {
        const firstInvalid = ['firstName', 'lastName', 'email'].find(field => this.$v[field].$invalid)
        if (firstInvalid) this.focusField(firstInvalid)
        return
      }
      trackClick(this, 'next', this.analyticsDims)
      this.setPatientInfo({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email
      })
      this.$router.push({ name: 'Recommend' })
    }
  }
}
</script>

<style lang="scss" scoped>
.reputation-row {
  display: flex;
  gap: 12px;
  margin-bottom: 4px;
}

.reputation-col {
  flex: 1;
  min-width: 0;
}

.validation-error {
  color: $text-error;
  display: block;
  font-size: 12px;
}

.btn-next {
  display: block;
  height: 36px;
  margin: 12px 0 0;
  width: 100%;
}
</style>
